import Main from './components/Main.vue'
import Info from './components/Info.vue'
import Members from './components/members/Main.vue'
import Form from './components/members/Form.vue'
import Billing from './components/billing/Main.vue'
import CreditCardForm from './components/billing/credit-card/Form.vue'
import AdditionalInformation from './components/AdditionalInformation.vue'
import Webhook from './components/Webhook.vue'

export default [
    {
        name: 'company.index',
        path: '/company',
        redirect: '/company/info',
        component: Main,
        meta: {
            requiresAuth: true,
            isAdminRoute: true
        },
        children: [
            {
                name: 'company.info',
                path: '/company/info',
                component: Info,
                meta: {
                    requiresAuth: true,
                    isAdminRoute: true
                }
            },
            {
                name: 'company.members',
                path: '/company/members',
                component: Members,
                meta: {
                    requiresAuth: true,
                    isAdminRoute: true
                },
                children: [
                    {
                        name: 'company.members.create',
                        path: '/company/members/create',
                        component: Form,
                        meta: {
                            requiresAuth: true,
                            isAdminRoute: true
                        }
                    }
                ]
            },
            {
                name: 'company.billing',
                path: '/company/billing',
                component: Billing,
                meta: {
                    requiresAuth: true,
                    isAdminRoute: true
                },
                children: [
                    {
                        name: 'company.billing.credit-card.form',
                        path: '/company/billing/credit-card/form',
                        component: CreditCardForm,
                        meta: {
                            requiresAuth: true,
                            isAdminRoute: true
                        }
                    }
                ]
            },
            {
                name: 'company.additional-information',
                path: '/company/additional-information',
                component: AdditionalInformation,
                meta: {
                    requiresAuth: true,
                    isAdminRoute: true
                }
            },
            {
                name: 'company.webhook',
                path: '/company/webhook',
                component: Webhook,
                meta: {
                    requiresAuth: true,
                    isAdminRoute: true
                }
            }
        ]
    }
]



// WEBPACK FOOTER //
// ./src/modules/company/routes.js